// vendor
import { useStore } from 'react-redux';
// utils
import {
    scriptIsAlreadyLoaded,
    buildVerticalUrl,
    getVerticalContent,
    addScript,
    prepareSrc,
    getSessionData
} from './dynamicLoad.utils';
import { replaceReducers } from "core/storeHelper";
// errors
import { LoadScriptVerticalError, WindowGlobalVerticalError } from './dynamicLoad.error';

export const useDynamicLoad = (vertical, history) => {
    const store = useStore();

    const initializeVertical = () => {
        if (!window.globals[vertical.id]) {
            throw new WindowGlobalVerticalError(`Error for vertical ${vertical.proxy}`);
        }

        try {
            replaceReducers(
                vertical.id,
                window.globals[vertical.id].reducers,
                window.globals[vertical.id].commonReducers,
            );
            const sessionData = getSessionData();
            window.globals[vertical.id].entrypoint(
                document.getElementById(`${vertical.id}-microfrontend`),
                store,
                history,
                {},
                {},
                {
                    sessionData
                }
            );
        } catch (e) {
            throw new WindowGlobalVerticalError(`Error for vertical ${vertical.proxy}: ${e.message}`);
        }
    };

    const loadVertical = async () => {
        let src;
        const url = buildVerticalUrl(vertical.proxy);
        const htmlText = await getVerticalContent(url);
        try {
            src = prepareSrc(htmlText);
        } catch (e) {
            throw new LoadScriptVerticalError(`Failed loading script for vertical ${vertical.proxy}: ${e.message}`);
        }
        await addScript(src, vertical);
    };

    const doWaitVerticalLoad = (
        verticalName,
        resolve,
        reject,
        ttl
      ) => {
        const vertical = window.globals && window.globals[verticalName];
        if (vertical && vertical['entrypoint']) {
          resolve();
        } else {
          if (ttl <= 0) {
            reject();
          } else {
            ttl--;
            setTimeout(() => {
              doWaitVerticalLoad(verticalName, resolve, reject, ttl);
            }, 1000);
          }
        }
      };

    const waitVerticalLoad = async (verticalName) => {
        return new Promise((resolve, reject) => {
          doWaitVerticalLoad(verticalName, resolve, reject, 5);
        });
      };

    const prepareVertical = async () => {
        if (scriptIsAlreadyLoaded(vertical)) {
            initializeVertical();
        } else {
            try {
                await loadVertical();
                await waitVerticalLoad(vertical.id);
                initializeVertical();
            }catch(error) {
                throw new WindowGlobalVerticalError(
                    `Error for vertical ${vertical} (${error})`
                );
            }
        }
    };

    return {
        prepareVertical,
    };
};
